import React, { useState, useEffect, useRef } from 'react';
import './apply-now.css';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import ThankYou from './ThankYou';
import {
  checkMultiVerticalPan,
  evaluateMultiVerticalPan,
} from '../config/taskApi';

const ApplyNow = () => {

const lastFetchedPanRef = useRef("");

const [formData, setFormData] = useState({
    loanAmount: '',
    monthlyIncome: '',
    firstName: '',
    middleName: '',
    lastName: '',
    panNumber: '',
    dob: '',
    gender: '',
    mobile: '',
    altMobile: '',
    email: '',
    officialEmail: '',
    obligations: '',
    state: '',
    city: '',
    pincode: '',       
    city_name: "",
    state_name: "",
    term_and_condition: false,
    notification_consent: false,
});

const [errors, setErrors] = useState({});
const [states, setStates] = useState([]);
const [cities, setCities] = useState([]);
const [stateId, setStateId] = useState('');
const [cityId, setCityId] = useState('');
const [pincodeList, setPincodeList] = useState([]);
const [formSubmitted, setFormSubmitted] = useState(false);
const [panExists, setPanExists] = useState(false);
const [panInfo, setPanInfo] = useState('');


useEffect(() => {
    axios.get('https://dhanwalle.in/Api/TaskApi/getState')
    .then(res => {
        if (res.data.Status === 1) {
        setStates(res.data.Data);
        } else {
        alert(res.data.Message || 'Failed to fetch states');
        }
    })
    .catch(err => {
        console.error('Failed fetching states:', err);
        alert('Could not load states');
    });
}, []);

const handleChange = (e) => {
let { id, value, type, checked } = e.target;
let error = "";

// PAN logic
if (id === "panNumber") {
  value = value.toUpperCase().trim();

  if (value.length !== 10) {
    setPanInfo("");
  }

  if (lastFetchedPanRef.current && value !== lastFetchedPanRef.current) {
    setFormData(prev => ({
      ...prev,
      firstName: "", middleName: "", lastName: "", dob: "",
      gender: "", mobile: "", altMobile: "", email: "",
      officialEmail: "", obligations: "", pincode: "",
      city_name: "", state_name: "", term_and_condition: false
    }));

    setStateId("");
    setCityId("");
    lastFetchedPanRef.current = "";
    setPanInfo("");
  }

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

  if (value.length === 10) {
    if (!panRegex.test(value)) {
      error = "Invalid PAN format";
    } else {
      checkPanVal(value);
    }
  }
}

// Mobile validation
if (id === "mobile" || id === "altMobile") {
    // Step 1: Check if length is exactly 10
    if (value.length > 0 && value.length !== 10) {
        error = "Enter 10-digit number";
    }

    // Step 2: Check for duplicate number in real-time
    const otherField = id === "mobile" ? formData.altMobile : formData.mobile;
    if (value && value === otherField) {
        error = "Both numbers cannot be same";
    }
}

setFormData(prev => ({
  ...prev,
  [id]: type === "checkbox" ? checked : value
}));

setErrors(prev => ({
  ...prev,
  [id]: error
}));
};

// âœ… ðŸ‘‡ Paste this RIGHT BELOW handleChange
const handleKeyPress = (e, fieldName) => {
if (!/[0-9]/.test(e.key)) {
    e.preventDefault();
    setErrors(prev => ({
    ...prev,
    [fieldName]: 'Only digits are allowed',
    }));
} else {
    // Clear the error if valid key is pressed
    setErrors(prev => ({
    ...prev,
    [fieldName]: '',
    }));
}
};


const handleStateChange = async (e) => {
    const sid = e.target.value;
    const selectedState = states.find(s => s.state_id.toString() === sid);

    setFormData(prev => ({ ...prev, state: selectedState?.state || '', city: '', pincode: '' }));
    setStateId(sid);
    setCityId('');
    setCities([]);
    setPincodeList([]);
    setErrors(prev => ({ ...prev, state: '', city: '', pincode: '' }));

    if (!sid) return;

    try {
    const resp = await axios.post(
        'https://dhanwalle.in/Api/TaskApi/getCity',
        { state_id: sid },
        { headers: { 'Content-Type': 'application/json' } }
    );
    if (resp.data.Status === 1) {
        setCities(resp.data.Data);
    } else {
        setCities([]);
    }
    } catch (err) {
    console.error('Failed fetching cities:', err);
    setCities([]);
    }
};

const handleCityChange = async (e) => {
    const cid = e.target.value;
    const selectedCity = cities.find(c => c.city_id.toString() === cid);

    setFormData(prev => ({
    ...prev,
    city: selectedCity?.city || '',
    pincode: ''
    }));
    setCityId(cid);
    setErrors(prev => ({ ...prev, city: '', pincode: '' }));

    try {
    const resp = await axios.post(
        'https://dhanwalle.in/Api/TaskApi/getPincodeByCityId',
        { city_id: cid },
        { headers: { 'Content-Type': 'application/json' } }
    );

    if (resp.data.Status === 1) {
        setPincodeList(resp.data.Data);
    } else {
        setPincodeList([]);
    }
    } catch (err) {
    console.error('Failed fetching pincodes:', err);
    setPincodeList([]);
    }
};


const getFreshPanMessage = (apiMessage) => {
  const raw = (apiMessage || "").trim();
  const normalized = raw.toLowerCase();

  if (
    !normalized ||
    normalized.includes("customer not found") ||
    normalized.includes("not found")
  ) {
    return "No existing customer found. Please fill your details.";
  }

  return raw;
};

const checkPanVal = async (pan) => {
    try {
      // 1) FIRST: multi-vertical DISBURSED check
      let multiRes;
      try {
        multiRes = await checkMultiVerticalPan(pan);
      } catch (err) {
        console.error("Multi-vertical PAN Check Error:", err);
        setPanExists(true);
        setPanInfo("");
        setErrors((prev) => ({
          ...prev,
          panNumber:
            "We could not verify your PAN right now. Please try again in a moment.",
        }));
        lastFetchedPanRef.current = "";
        return;
      }

      const multiCheck = evaluateMultiVerticalPan(multiRes);
      if (!multiCheck.allowed) {
        setPanExists(true);
        setPanInfo("");
        setErrors((prev) => ({
          ...prev,
          panNumber: multiCheck.message,
        }));
        lastFetchedPanRef.current = "";
        return;
      }

      // 2) Then existing customer check + autofill
      const resp = await axios.get(
        "https://dhanwalle.in/Api/TaskApi/checkGetCustomerbyPan",
        {
          params: { pancard: pan },
          validateStatus: () => true,
        }
      );

      const data = resp.data || {};

      if (data.status === true) {
        const d = data.data;

        lastFetchedPanRef.current = pan;

        setFormData(prev => ({
          ...prev,
          firstName: d.first_name || "",
          middleName: d.middle_name || "",
          lastName: d.sur_name || "",
          dob: d.dob || "",
          gender: d.gender || "",
          mobile: d.mobile || "",
          altMobile: d.alternate_mobile || "",
          email: d.email || "",
          officialEmail: d.alternate_email || "",
          obligations: d.obligations ? String(parseInt(d.obligations, 10)) : "",
          pincode: d.pincode || "",
          city_name: d.city_name || "",
          state_name: d.state_name || "",
          city: d.city_name || "",
          state: d.state_name || "",
          term_and_condition: d.term_and_condition === "YES"
        }));

        setStateId(d.state_id || "");
        setCityId(d.city_id || "");

        if (d.status === "CLOSED" || d.status === "REJECT" || d.status === "REJECTED") {
          setPanExists(false);
          setPanInfo(`Latest Status: ${d.status} (You can re-apply)`);
          setErrors(prev => ({ ...prev, panNumber: "" }));
        } else {
          setPanExists(true);
          setPanInfo("");
          setErrors(prev => ({
            ...prev,
            panNumber: `Your loan status is ${d.status}. Cannot re-apply.`
          }));
        }
      } else {
        const apiMsg = getFreshPanMessage(
          data.message || data.Message
        );

        setPanExists(false);
        setPanInfo(apiMsg);
        setErrors(prev => ({ ...prev, panNumber: "" }));
        lastFetchedPanRef.current = "";
      }
    } catch (err) {
      console.error("PAN Check Error:", err);
      const responseData = err.response?.data;
      if (responseData) {
        const apiMsg = getFreshPanMessage(
          responseData.message || responseData.Message
        );
        setPanExists(false);
        setPanInfo(apiMsg);
        setErrors(prev => ({ ...prev, panNumber: "" }));
        lastFetchedPanRef.current = "";
      } else {
        setPanExists(false);
        setPanInfo("");
        setErrors(prev => ({ ...prev, panNumber: "" }));
      }
    }
  };


const validate = () => {
const newErrors = {};
const onlyDigits = /^\d+$/;

if (!formData.loanAmount) newErrors.loanAmount = 'Required';
if (!formData.monthlyIncome) newErrors.monthlyIncome = 'Required';
if (!formData.firstName) newErrors.firstName = 'Required';
if (!formData.panNumber) newErrors.panNumber = 'Required';
if (!formData.dob) newErrors.dob = 'Required';
if (!formData.gender) newErrors.gender = 'Required';

// Personal Mobile Validation
if (!formData.mobile) {
    newErrors.mobile = 'Required';
} else if (!onlyDigits.test(formData.mobile) || formData.mobile.length !== 10) {
    newErrors.mobile = 'Enter valid 10-digit mobile number';
}

// Alternate Mobile Validation (Required, 10 digits, and Unique)
if (!formData.altMobile) {
    newErrors.altMobile = 'Alternate mobile is required';
} else if (!onlyDigits.test(formData.altMobile) || formData.altMobile.length !== 10) {
    newErrors.altMobile = 'Enter valid 10-digit alternate number';
} else if (formData.altMobile === formData.mobile) {
    newErrors.altMobile = 'Alternate number must be different from primary mobile';
}

if (!formData.email) newErrors.email = 'Required';
if (!formData.state) newErrors.state = 'Required';
if (!formData.city) newErrors.city = 'Required';
if (!formData.pincode) newErrors.pincode = 'Required';

if (!formData.term_and_condition) {
    newErrors.term_and_condition = 'Please accept the terms';
}

if (!formData.notification_consent) {
    newErrors.notification_consent = 'Please authorise notifications to continue';
}

return newErrors;
};

const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validate();
    
    if (Object.keys(formErrors).length) {
        setErrors(formErrors);
        return;
    }

    const payload = {
        loan_amount: formData.loanAmount,
        monthly_income: formData.monthlyIncome,
        first_name: formData.firstName,
        middle_name: formData.middleName || null,
        sur_name: formData.lastName || null,
        pan: formData.panNumber,
        dob: formData.dob,
        gender: formData.gender.toUpperCase(),
        mobile: formData.mobile,
        alternate_mobile: formData.altMobile || null,
        otp: 1234,
        email_personal: formData.email,
        email_official: formData.officialEmail || null,
        obligations: formData.obligations || null,
        state_id: stateId,
        city: cityId,
        pin: formData.pincode,
        term_and_condition: formData.term_and_condition ? 'YES' : 'NO', 
        ip: '106.219.215.60',
        coordinates: null,
        source: 'Dhanwalle',
        lead_data_source_id: 38,
        utm_source: '',
        utm_campaign: null,
    };

    try {
        const resp = await axios.post(
            'https://dhanwalle.in/Api/TaskApi/saveLendingPage',
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        if (resp.data.Status === 1) {
            setFormSubmitted(true);
            const trackingLink = "https://dhanwalle.com/check"; 
            const smsVariables = `${formData.firstName}| ${trackingLink}|`;
            const smsUrl = `https://www.fast2sms.com/dev/bulkV2?authorization=CNHnel3FiDU6P0GXQh7yVuMzER5cI4pogAJsBS9kxKbZaw1Y2LN8cOnHPz3G2QdRbeom7UJsfKviLyMZ&route=dlt&sender_id=VMCRED&message=207219&variables_values=${encodeURIComponent(smsVariables)}&flash=0&numbers=${encodeURIComponent(formData.mobile)}`;

            try {
                const smsResp = await axios.get(smsUrl);
                console.log("SMS API response:", smsResp.data);
            } catch (smsErr) {
                console.error("SMS API error:", smsErr);
            }
        } else {
            const plainTextMessage = resp.data.Message.replace(/<[^>]+>/g, "\n").trim();
            alert(plainTextMessage || "Submit failed");
        }
    } catch (err) {
        console.error('Submit error:', err);
        alert('Submit failed');
    }
};

if (formSubmitted) {
    return <ThankYou />;
}

return (
    <div className="apply-now-wrapper">
    <Container className="apply-now-form-container">
        <h2 className="form-heading">Apply Now</h2>
        <Form onSubmit={handleSubmit} noValidate className="apply-now-form">

        <Row className="apply-form-row g-3">
            <Col md={6}>
            <Form.Group controlId="panNumber" className="mb-0 apply-form-field pan-field-group">
                <Form.Label>PAN Number <span className="required">*</span></Form.Label>
                <Form.Control
                type="text"
                maxLength="10"
                value={formData.panNumber}
                onChange={handleChange}
                isInvalid={!!errors.panNumber}
                placeholder="Enter your pan number"
                />
                {panInfo && <div className="pan-info-message">{panInfo}</div>}
                <Form.Control.Feedback type="invalid">{errors.panNumber}</Form.Control.Feedback>
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="loanAmount" className="mb-0 apply-form-field">
                <Form.Label>Loan Amount <span className="required">*</span></Form.Label>
                <Form.Control
                type="number"
                value={formData.loanAmount}
                onChange={handleChange}
                isInvalid={!!errors.loanAmount}
                />
                <Form.Control.Feedback type="invalid">{errors.loanAmount}</Form.Control.Feedback>
            </Form.Group>
            </Col>
        </Row>

        <Row className="apply-form-row g-3">
            <Col md={6}>
            <Form.Group controlId="monthlyIncome" className="mb-0 apply-form-field">
                <Form.Label>Monthly Income <span className="required">*</span></Form.Label>
                <Form.Control
                type="number"
                value={formData.monthlyIncome}
                onChange={handleChange}
                isInvalid={!!errors.monthlyIncome}
                />
                <Form.Control.Feedback type="invalid">{errors.monthlyIncome}</Form.Control.Feedback>
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="firstName" className="mb-0 apply-form-field">
                <Form.Label>First Name <span className="required">*</span></Form.Label>
                <Form.Control
                type="text"
                value={formData.firstName}
                onChange={handleChange}
                isInvalid={!!errors.firstName}
                />
                <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
            </Form.Group>
            </Col>
        </Row>

        <Row className="apply-form-row g-3">
            <Col md={6}>
            <Form.Group controlId="middleName" className="mb-0 apply-form-field">
                <Form.Label>Middle Name</Form.Label>
                <Form.Control
                type="text"
                value={formData.middleName}
                onChange={handleChange}
                />
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="lastName" className="mb-0 apply-form-field">
                <Form.Label>Surname</Form.Label>
                <Form.Control
                type="text"
                value={formData.lastName}
                onChange={handleChange}
                />
            </Form.Group>
            </Col>
        </Row>

        <Row className="apply-form-row g-3">
            <Col md={6}>
            <Form.Group controlId="dob" className="mb-0 apply-form-field">
                <Form.Label>Date of Birth <span className="required">*</span></Form.Label>
                <Form.Control
                type="date"
                value={formData.dob}
                onChange={handleChange}
                isInvalid={!!errors.dob}
                />
                <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="gender" className="mb-0 apply-form-field">
                <Form.Label>Gender <span className="required">*</span></Form.Label>
                <Form.Select
                value={formData.gender}
                onChange={handleChange}
                isInvalid={!!errors.gender}
                >
                <option value="">Select Gender</option>
                <option value="MALE">MALE</option>
                <option value="FEMALE">FEMALE</option>
                <option value="OTHER">OTHER</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.gender}</Form.Control.Feedback>
            </Form.Group>
            </Col>
        </Row>

        <Row className="apply-form-row g-3">
            <Col md={6}>
                <Form.Group controlId="mobile" className="mb-0 apply-form-field">
                    <Form.Label>Mobile <span className="required">*</span></Form.Label>
                    <Form.Control
                        type="tel"
                        maxLength="10"
                        value={formData.mobile}
                        onChange={handleChange}
                        onKeyPress={(e) => handleKeyPress(e, 'mobile')}
                        isInvalid={!!errors.mobile}
                    />
                    <div className="field-feedback-slot field-feedback-slot--error">
                        {errors.mobile || ''}
                    </div>
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group controlId="altMobile" className="mb-0 apply-form-field">
                    <Form.Label>Alternate Mobile <span className="required">*</span></Form.Label>
                    <Form.Control
                        type="tel"
                        maxLength="10"
                        value={formData.altMobile}
                        onChange={handleChange}
                        onKeyPress={(e) => handleKeyPress(e, 'altMobile')}
                        isInvalid={!!errors.altMobile}
                    />
                    <div className="field-feedback-slot field-feedback-slot--error">
                        {errors.altMobile || ''}
                    </div>
                </Form.Group>
            </Col>
        </Row>

        <Row className="apply-form-row g-3">
            <Col md={6}>
            <Form.Group controlId="email" className="mb-0 apply-form-field">
                <Form.Label>Email <span className="required">*</span></Form.Label>
                <Form.Control
                type="email"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="officialEmail" className="mb-0 apply-form-field">
                <Form.Label>Official Email</Form.Label>
                <Form.Control
                type="email"
                value={formData.officialEmail}
                onChange={handleChange}
                />
            </Form.Group>
            </Col>
        </Row>

        <Row className="apply-form-row g-3">
            <Col md={6}>
                <Form.Group controlId="obligations" className="mb-0 apply-form-field">
                    <Form.Label>Obligations</Form.Label>
                    <Form.Control
                        type="text"
                        maxLength="7"
                        value={formData.obligations}
                        onChange={handleChange}
                        onKeyPress={(e) => handleKeyPress(e, 'obligations')}
                        isInvalid={!!errors.obligations}
                    />
                    <div className="field-feedback-slot field-feedback-slot--error">
                        {errors.obligations || ''}
                    </div>
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group controlId="state" className="mb-0 apply-form-field">
                    <Form.Label>State <span className="required">*</span></Form.Label>
                    {formData.state_name !== '' ? (
                    <>
                        <Form.Control type="hidden" name="state_id" value={formData.state_id} />
                        <Form.Control type="text" value={formData.state_name} readOnly />
                    </>
                    ) : (
                    <Form.Select value={stateId} onChange={handleStateChange} isInvalid={!!errors.state}>
                        <option value="">Select State</option>
                        {states.map(s => (
                        <option key={s.state_id} value={s.state_id}>{s.state}</option>
                        ))}
                    </Form.Select>
                    )}
                    <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>

        <Row className="apply-form-row g-3">
            <Col md={6}>
                <Form.Group controlId="city" className="mb-0 apply-form-field">
                    <Form.Label>City</Form.Label>
                    {formData.city_name !== '' ? (
                    <>
                        <Form.Control type="hidden" name="city_id" value={formData.city_id} />
                        <Form.Control type="text" value={formData.city_name} readOnly />
                    </>
                    ) : (
                    <Form.Select value={cityId} onChange={handleCityChange}>
                        <option value="">Select City</option>
                        {cities.map(city => (
                        <option key={city.city_id} value={city.city_id}>{city.city}</option>
                        ))}
                    </Form.Select>
                    )}
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group controlId="pincode" className="mb-0 apply-form-field">
                    <Form.Label>Pincode</Form.Label>
                    {formData.pincode !== '' ? (
                        <Form.Control type="text" value={formData.pincode} readOnly />
                    ) : (
                        <Form.Select
                        value={formData.pincode}
                        onChange={handleChange}
                        disabled={!cityId || pincodeList.length === 0}
                        >
                        <option value="">Select Pincode</option>
                        {pincodeList.map(pin => (
                            <option key={pin.m_pincode_id} value={pin.m_pincode_value}>
                            {pin.m_pincode_value}
                            </option>
                        ))}
                        </Form.Select>
                    )}
                    <div className="field-feedback-slot field-feedback-slot--error">
                        {errors.pincode || ''}
                    </div>
                </Form.Group>
            </Col>
        </Row>

        <Form.Group controlId="term_and_condition" className="mb-3 terms-check">
<Form.Check
type="checkbox"
label={
  <>
    <a href="terms-conditions" target="_blank">Terms & Conditions</a> <span className="required">*</span>
  </>
}
checked={formData.term_and_condition}
onChange={handleChange} // <-- Yeh change kiya
isInvalid={!!errors.term_and_condition}
/>
{errors.term_and_condition && (
<div className="text-danger" style={{ fontSize: '0.8rem' }}>
  {errors.term_and_condition}
</div>
)}
</Form.Group>

<div className="declaration-text mb-3">
I hereby declare that all the above information provided by me is true, correct, and verified to the best of my knowledge. <span className="required">*</span>
</div>

<Form.Group controlId="notification_consent" className="mb-3 terms-check">
<Form.Check
type="checkbox"
label={
  <>
    I hereby authorise to send notifications via SMS, Email, RCS and others as per{' '}
    <a href="terms-conditions" target="_blank" rel="noopener noreferrer">Terms of Service</a>
    /
    <a href="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    <span className="required"> *</span>
  </>
}
checked={formData.notification_consent}
onChange={handleChange}
isInvalid={!!errors.notification_consent}
/>
{errors.notification_consent && (
<div className="text-danger" style={{ fontSize: '0.8rem' }}>
  {errors.notification_consent}
</div>
)}
</Form.Group>

<div className="submit-btn-wrapper">

<Button 
type="submit" 
className="apply-submit-btn"
disabled={panExists === true && !errors.panNumber?.includes("REJECT")}
>
Submit
</Button>
</div>

        </Form>
    </Container>
    </div>
);
};

export default ApplyNow;



